module.exports = __webpack_public_path__ + "static/media/bite-me@3x.c084f23a.jpg";